module.exports = __webpack_public_path__ + "static/logo_sinarmas-dark-2d2bb249299fda48ad4a9d199e44c467.png";